import { useEffect } from 'react';
import type { IipServiceRootResponse } from 'src/apis/iip-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useIipService() {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<IipServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.iipService,
      }),
    { neededOnPageLoad: true, cacheKey: 'iip-service-root' }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type IipServiceRequest = ReturnType<typeof useIipService>;
